import React from 'react'
import styles from './styles.css'

const LiveItem = ({ itemData, handleClick }) => {
  const {
    itemContainer,
    priceGroupWrap,
    contentWrap,
    imgWrap,
    btnWrap,
    titleStyle,
    descriptionStyle,
    pricetStyle,
  } = styles
  const { thumbnail, title, description, price, url } = itemData
  return (
    <div className={itemContainer}>
      <div className={imgWrap}>
        <img src={thumbnail} alt="" />
      </div>
      <div className={contentWrap}>
        <div className={titleStyle}>{title}</div>
        <div className={descriptionStyle}>{description}</div>
      </div>
      <div className={priceGroupWrap}>
        <div className={btnWrap} onClick={handleClick(url)}>
          会员免费
        </div>
        <div className={pricetStyle}>{`原价 ￥${price}`}</div>
      </div>
    </div>
  )
}

export default LiveItem



// WEBPACK FOOTER //
// ./src/modules/Live/item.js